export default "__VITE_ASSET__DGOK26J5__"